/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: s3-temp-file-upload-service.ts
 *
 * Created by kyang on 2021-02-25.
 */

// This service is an implementation for TempFileUploadService.

angular.module('prism-ui.components').service('S3TempFileUploadService', function (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    AWS: JS5Object,
    TempFileUploadService: JS5Object,
) {

    this.initialize = (fileUploader: JS5Object) => {
        // Nothing to initialize
    };

    this.uploadFileToTemp = (fileUploader: JS5Object, fileItem: JS5Object, index: number, uploadInfo: JS5Object, targetSubdirectory: string, targetPackageId: string) => {
        return TempFileUploadService.getTempDirectoryConfiguration().then((tempDirConfig: JS5Object) => {
            if (!tempDirConfig.tempCredentialsSupported) {
                return $q.reject({
                    message: 'Webapp is not configured to upload to temp S3 directory'
                });
            }
            return uploadToTempS3(fileItem._file, targetSubdirectory, tempDirConfig, uploadInfo);
        });
    };

    const getVirtualPath = (bucket: string, s3Key: string) => {
        // virtualPath can be set to S3 URIs for ingests
        return `s3:${bucket}:${s3Key}`;
    };

    const uploadToTempS3 = (
        file: File,
        targetSubdirectory: string,
        tempDirConfig: JS5Object,
        uploadInfo: JS5Object,
    ) => {
        return TempFileUploadService.getTempUploadCredentials(file.name, targetSubdirectory).then((uploadCredentials: JS5Object) => {
            let bucket = uploadCredentials.bucket;
            let s3Path = uploadCredentials.key;
            let s3Client = new AWS.S3({
                params: {Bucket: bucket},
                credentials: new AWS.Credentials(uploadCredentials.credentials),
                region: tempDirConfig.region,
                endpoint: uploadCredentials.credentials.endpoint ? uploadCredentials.credentials.endpoint : undefined,
                useAccelerateEndpoint: uploadCredentials.credentials.useAcceleration === 'true',
            });
            let upload = s3Client.upload({
                Key: s3Path,
                ContentType: file.type,
                Body: file,
                Bucket: bucket
            });

            upload.on('httpUploadProgress', (event: JS5Object) => {
                uploadInfo.extraProps.deferredVirtualPath.resolve(getVirtualPath(bucket, event.key));
                if (!!event.total) {
                    uploadInfo.progressObservable.onNext(event.loaded / event.total);
                }
            });
            return upload.promise();
        });
    };

    this.cleanup = (fileUploader: JS5Object) => {
        // Nothing to cleanup
    };
});


//=================//
// Lifecycle Hooks //
//=================//

// Load this service when app is initialized
angular.module('prism-ui.components').run((
    S3TempFileUploadService: JS5Object,
    TempFileUploadService: JS5Object,
) => {
    TempFileUploadService.registerTempFileUploadServiceImplementation('S3', S3TempFileUploadService);
});
